/* eslint-disable indent */
/* eslint-disable prettier/prettier */
import { ObjectId } from 'bson';
import { _BaseModel } from './helpers/_BaseModel';
_BaseModel.addDictionary({modelName:'ProjectTimeReport',dictionary:{"de":{"references":{"project":"Projekt","responsibleWorker":"Verantwortlicher Mitarbeiter","lessonsLearned":"Erkenntnisse"},"projectTimeReportId":"BSB-ID","date":"Datum","remark":"Anmerkung","status":"Status","__getters":{"calendarWeek":"Kalenderwoche","dateCalendarWeek":"Datum","dateCalendarWeekDay":"Datum"}},"en":{"references":{"project":"Project","responsibleWorker":"Responsible Worker","lessonsLearned":"Lessons learned"},"projectTimeReportId":"Daily Work Record-ID","date":"Date","remark":"Remark","status":"Status","__getters":{"calendarWeek":"Calenderweek","dateCalendarWeek":"Date","dateCalendarWeekDay":"Date"}}}})
import { Login } from './Login';
import { Project } from './Project';
import { Worker } from './Worker';
import { LessonsLearned } from './LessonsLearned';
import { WorkRecord } from './WorkRecord';
import { WorkTime } from './WorkTime';
import { Absence } from './Absence';

export class ProjectTimeReport extends _BaseModel {
	
	static toString() {
		return 'ProjectTimeReport'
	}
	
	get __getters() {
		const self = this;
		return {
			get calendarWeek() {
        // eslint-disable-next-line no-undef
        return _BaseModel.getFunctions.calendarWeek(self.date);
    },
			get dateCalendarWeek() {
        // eslint-disable-next-line no-undef
        return _BaseModel.getFunctions.dateCalendarWeek(self.date);
    },
			get dateCalendarWeekDay() {
        // eslint-disable-next-line no-undef
        return _BaseModel.getFunctions.dateCalendarWeekDay(self.date);
    },
		}
	}
	
	static get paths() {
		return 			{
			meta: 				{
					
	locked:{
		type: 'boolean',
		__component: 'v-checkbox',
    __get: _BaseModel.getFunctions.boolean,
		__bind: {				label: _BaseModel.t('models.ProjectTimeReport.meta.locked'),
				rules: [ (value)=> (value === undefined || value === null || typeof value === 'boolean') || _BaseModel.t('rules.type.boolean', {modelName:'ProjectTimeReport', path:'meta.locked'}) ],
},
    
	},
	
					
	createdAt:{
		type: 'date',
		__component: 'date-picker',
    
		__bind: {				label: _BaseModel.t('models.ProjectTimeReport.meta.createdAt'),
				rules: [ (value)=>  (value === undefined || value === null || value instanceof Date) || _BaseModel.t('rules.type.date', {modelName:'ProjectTimeReport', path:'meta.createdAt'}) ],
},
    
	},
	
					
	updatedAt:{
		type: 'date',
		__component: 'date-picker',
    
		__bind: {				label: _BaseModel.t('models.ProjectTimeReport.meta.updatedAt'),
				rules: [ (value)=>  (value === undefined || value === null || value instanceof Date) || _BaseModel.t('rules.type.date', {modelName:'ProjectTimeReport', path:'meta.updatedAt'}) ],
},
    
	},
	
					
	createdBy:{
		type: 'objectId',
		__component: 'model-autocomplete',
    
		__bind: {				label: _BaseModel.t('$global.models.Login'),
				rules: [ (value) => (value === undefined || value === null || typeof value === 'string' || value instanceof Login) || _BaseModel.t('rules.reference', {modelName:'ProjectTimeReport', path:'meta.createdBy'}) ],
				model: Login,
				returnObject: true,
},
    
	},
	
					
	updatedBy:{
		type: 'objectId',
		__component: 'model-autocomplete',
    
		__bind: {				label: _BaseModel.t('$global.models.Login'),
				rules: [ (value) => (value === undefined || value === null || typeof value === 'string' || value instanceof Login) || _BaseModel.t('rules.reference', {modelName:'ProjectTimeReport', path:'meta.updatedBy'}) ],
				model: Login,
				returnObject: true,
},
    
	},
	
					
	archived:{
		type: 'boolean',
		__component: 'v-checkbox',
    __get: _BaseModel.getFunctions.boolean,
		__bind: {				label: _BaseModel.t('models.ProjectTimeReport.meta.archived'),
				rules: [ (value)=> (value === undefined || value === null || typeof value === 'boolean') || _BaseModel.t('rules.type.boolean', {modelName:'ProjectTimeReport', path:'meta.archived'}) ],
},
    
	},
	
					
	currentDocument:{
		type: 'objectId',
		__component: 'model-autocomplete',
    
		__bind: {				label: _BaseModel.t('$global.models.ProjectTimeReport'),
				rules: [ (value) => (value === undefined || value === null || typeof value === 'string' || value instanceof ProjectTimeReport) || _BaseModel.t('rules.reference', {modelName:'ProjectTimeReport', path:'meta.currentDocument'}) ],
				model: ProjectTimeReport,
				returnObject: true,
},
    
	},
	
					
	revisions:{
		type: 'array',
		__component: 'model-autocomplete',
    
		__bind: {				label: _BaseModel.t('$global.models._Revision'),
				rules: [ (value) => (value === undefined || value === null || Array.isArray(value)) || _BaseModel.t('rules.array', {modelName:'ProjectTimeReport', path:'meta.revisions'}) ],
				model: ProjectTimeReport,
				returnObject: true,
				multiple: true,
},
    
	},
	
},
			references: 				{
					
	project:{
		type: 'objectId',
		__component: 'model-autocomplete',
    
		__bind: {				label: _BaseModel.t('$global.models.Project'),
				rules: [ (value) => !!value || _BaseModel.t('rules.required', {modelName:'ProjectTimeReport', path:'references.project'}),(value) => (value === undefined || value === null || typeof value === 'string' || value instanceof Project) || _BaseModel.t('rules.reference', {modelName:'ProjectTimeReport', path:'references.project'}) ],
				model: Project,
				returnObject: true,
},
    
	},
	
					
	responsibleWorker:{
		type: 'objectId',
		__component: 'model-autocomplete',
    
		__bind: {				label: _BaseModel.t('$global.models.Worker'),
				rules: [ (value) => !!value || _BaseModel.t('rules.required', {modelName:'ProjectTimeReport', path:'references.responsibleWorker'}),(value) => (value === undefined || value === null || typeof value === 'string' || value instanceof Worker) || _BaseModel.t('rules.reference', {modelName:'ProjectTimeReport', path:'references.responsibleWorker'}) ],
				model: Worker,
				returnObject: true,
},
    
	},
	
					
	lessonsLearned:{
		type: 'objectId',
		__component: 'model-autocomplete',
    
		__bind: {				label: _BaseModel.t('$global.models.LessonsLearned'),
				rules: [ (value) => (value === undefined || value === null || typeof value === 'string' || value instanceof LessonsLearned) || _BaseModel.t('rules.reference', {modelName:'ProjectTimeReport', path:'references.lessonsLearned'}) ],
				model: LessonsLearned,
				returnObject: true,
},
    
	},
	
					
	workers:{
		type: 'array',
		__component: 'model-autocomplete',
    
		__bind: {				label: _BaseModel.t('$global.models.Worker'),
				rules: [ (value) => (value === undefined || value === null || Array.isArray(value)) || _BaseModel.t('rules.array', {modelName:'ProjectTimeReport', path:'references.workers'}) ],
				model: Worker,
				returnObject: true,
				multiple: true,
},
    
	},
	
					
	workRecords:{
		type: 'array',
		__component: 'model-autocomplete',
    
		__bind: {				label: _BaseModel.t('$global.models.WorkRecord'),
				rules: [ (value) => (value === undefined || value === null || Array.isArray(value)) || _BaseModel.t('rules.array', {modelName:'ProjectTimeReport', path:'references.workRecords'}) ],
				model: WorkRecord,
				returnObject: true,
				multiple: true,
},
    
	},
	
					
	workTimes:{
		type: 'array',
		__component: 'model-autocomplete',
    
		__bind: {				label: _BaseModel.t('$global.models.WorkTime'),
				rules: [ (value) => (value === undefined || value === null || Array.isArray(value)) || _BaseModel.t('rules.array', {modelName:'ProjectTimeReport', path:'references.workTimes'}) ],
				model: WorkTime,
				returnObject: true,
				multiple: true,
},
    
	},
	
					
	absences:{
		type: 'array',
		__component: 'model-autocomplete',
    
		__bind: {				label: _BaseModel.t('$global.models.Absence'),
				rules: [ (value) => (value === undefined || value === null || Array.isArray(value)) || _BaseModel.t('rules.array', {modelName:'ProjectTimeReport', path:'references.absences'}) ],
				model: Absence,
				returnObject: true,
				multiple: true,
},
    
	},
	
},
				
	projectTimeReportId:{
		type: 'string',
		__component: 'v-text-field',
    
		__bind: {				label: _BaseModel.t('models.ProjectTimeReport.projectTimeReportId'),
				rules: [ (value)=> (value === undefined || value === null || typeof value === 'string') || _BaseModel.t('rules.type.string', {modelName:'ProjectTimeReport', path:'projectTimeReportId'}) ],
},
    
	},
	
				
	date:{
		type: 'date',
		__component: 'date-picker',
    
		__bind: {				label: _BaseModel.t('models.ProjectTimeReport.date'),
				rules: [ (value) => !!value || _BaseModel.t('rules.required', {modelName:'ProjectTimeReport', path:'date'}),(value)=>  (value === undefined || value === null || value instanceof Date) || _BaseModel.t('rules.type.date', {modelName:'ProjectTimeReport', path:'date'}) ],
},
    __isDate: true,
	},
	
				
	remark:{
		type: 'string',
		__component: 'v-textarea',
    
		__bind: {				label: _BaseModel.t('models.ProjectTimeReport.remark'),
				rows: 1,
				autoGrow: true,
				rules: [ (value)=> (value === undefined || value === null || typeof value === 'string') || _BaseModel.t('rules.type.string', {modelName:'ProjectTimeReport', path:'remark'}) ],
},
    
	},
	
				
	status:{
		type: 'string',
		__component: 'v-text-field',
    
		__bind: {				label: _BaseModel.t('models.ProjectTimeReport.status'),
				rules: [ (value)=> (value === undefined || value === null || typeof value === 'string') || _BaseModel.t('rules.type.string', {modelName:'ProjectTimeReport', path:'status'}) ],
},
    
	},
	
				
	_id:{
		type: 'objectId',
		__component: 'v-text-field',
    
		__bind: {				label: _BaseModel.t('models.ProjectTimeReport._id'),
				rules: [  ],
},
    
	},
	
}
	}
	constructor({meta={}, references={}, projectTimeReportId='', date=undefined, remark='', status='', _id=new ObjectId(), }={}){
		super();
		this.meta=MetaClass.create(meta);
		this.references=ReferencesClass.create(references);
		this.projectTimeReportId=projectTimeReportId;
		this.date=date;
		this.remark=remark;
		this.status=status;
		this._id=_id;
	}

	static create(data) {
		return new ProjectTimeReport(data);
	}
}

class MetaClass {
	constructor({locked=false, createdAt=undefined, updatedAt=undefined, createdBy=undefined, updatedBy=undefined, archived=false, currentDocument=undefined, revisions=[], __errors=[], }={}){
		this.locked=locked;
		this.createdAt=createdAt;
		this.updatedAt=updatedAt;
		this.createdBy= (createdBy instanceof Login || typeof createdBy === 'string' || !createdBy) ? createdBy : Login.create(createdBy);
		this.updatedBy= (updatedBy instanceof Login || typeof updatedBy === 'string' || !updatedBy) ? updatedBy : Login.create(updatedBy);
		this.archived=archived;
		this.currentDocument= (currentDocument instanceof ProjectTimeReport || typeof currentDocument === 'string' || !currentDocument) ? currentDocument : ProjectTimeReport.create(currentDocument);
		if(Array.isArray(revisions)){
			this.revisions=[];
			for(const item of revisions){
				if(typeof item === 'string') this.revisions.push(item)
				else if(typeof item === 'object')
					this.revisions.push(item instanceof ProjectTimeReport ? item : ProjectTimeReport.create(item))
				else throw new Error('unknown type for '+item)
			}
		} else {
			this.revisions=revisions;
		}
		this.__errors=__errors;
	}

	static create(data) {
		return new MetaClass(data);
	}
}

class ReferencesClass {
	constructor({project=undefined, responsibleWorker=undefined, lessonsLearned=undefined, workers=[], workRecords=[], workTimes=[], absences=[], }={}){
		this.project= (project instanceof Project || typeof project === 'string' || !project) ? project : Project.create(project);
		this.responsibleWorker= (responsibleWorker instanceof Worker || typeof responsibleWorker === 'string' || !responsibleWorker) ? responsibleWorker : Worker.create(responsibleWorker);
		this.lessonsLearned= (lessonsLearned instanceof LessonsLearned || typeof lessonsLearned === 'string' || !lessonsLearned) ? lessonsLearned : LessonsLearned.create(lessonsLearned);
		if(Array.isArray(workers)){
			this.workers=[];
			for(const item of workers){
				if(typeof item === 'string') this.workers.push(item)
				else if(typeof item === 'object')
					this.workers.push(item instanceof Worker ? item : Worker.create(item))
				else throw new Error('unknown type for '+item)
			}
		} else {
			this.workers=workers;
		}
		if(Array.isArray(workRecords)){
			this.workRecords=[];
			for(const item of workRecords){
				if(typeof item === 'object')
					this.workRecords.push(item instanceof WorkRecord ? item : WorkRecord.create(item))
				else this.workRecords.push(item)
			}
		} else {
			this.workRecords=workRecords;
		}
		if(Array.isArray(workTimes)){
			this.workTimes=[];
			for(const item of workTimes){
				if(typeof item === 'object')
					this.workTimes.push(item instanceof WorkTime ? item : WorkTime.create(item))
				else this.workTimes.push(item)
			}
		} else {
			this.workTimes=workTimes;
		}
		if(Array.isArray(absences)){
			this.absences=[];
			for(const item of absences){
				if(typeof item === 'object')
					this.absences.push(item instanceof Absence ? item : Absence.create(item))
				else this.absences.push(item)
			}
		} else {
			this.absences=absences;
		}
	}

	static create(data) {
		return new ReferencesClass(data);
	}
}
